import React from 'react';
const TermsPage = () => {
  return <div className="bg-white" data-id="element-1799">
      <div className="container mx-auto px-4 py-12" data-id="element-1800">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1801">
          Terms & Conditions
        </h1>
        <p className="mb-6" data-id="element-1802">
          <span className="text-burgundy-600" data-id="element-1803">N</span>orthampton{' '}
          <span className="text-burgundy-600" data-id="element-1804">D</span>riving{' '}
          <span className="text-burgundy-600" data-id="element-1805">S</span>chool – Learner Driver
          Terms & Conditions
        </p>
        <p className="mb-6" data-id="element-1806">
          By booking or attending lessons with Northampton Driving School, you
          agree to the following terms:
        </p>
        <section className="mb-8" data-id="element-1807">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1808">
            1. Eligibility
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1809">
            <li data-id="element-1810">
              You must hold a valid UK provisional or full driving licence
              recognised in the UK.
            </li>
            <li data-id="element-1811">
              You must show your licence to your instructor at your first lesson
              and whenever asked.
            </li>
            <li data-id="element-1812">
              Any penalty points, endorsements, or medical restrictions must be
              declared.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1813">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1814">
            2. Bookings & Payments
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1815">
            <li data-id="element-1816">
              Lessons must be booked through the school or directly with your
              instructor.
            </li>
            <li data-id="element-1817">
              Payment is required in advance to confirm bookings (individual
              lessons or block bookings).
            </li>
            <li data-id="element-1818">
              Block booking discounts apply only when full payment is made in
              advance.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1819">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1820">
            3. Attendance
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1821">
            <li data-id="element-1822">
              Your instructor will wait at the agreed pick-up point for up to 15
              minutes. If you do not attend, the lesson will be charged in full.
            </li>
            <li data-id="element-1823">All pick-up and drop-off points must be pre-agreed.</li>
            <li data-id="element-1824">
              If using your own car, it must be roadworthy, taxed, MOT'd, and
              insured for learner use. Proof of insurance must be shown each
              lesson.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1825">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1826">
            4. Lesson Conduct
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1827">
            <li data-id="element-1828">
              Pupils must follow the instructor's instructions at all times.
            </li>
            <li data-id="element-1829">
              Aggressive, unsafe, or abusive behaviour will result in immediate
              termination of lessons without refund.
            </li>
            <li data-id="element-1830">
              Pupils must wear suitable footwear (no flip-flops, high heels, or
              unsafe shoes).
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1831">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1832">
            5. Fitness to Drive
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1833">
            <li data-id="element-1834">
              You must not be under the influence of alcohol, drugs, or
              medication that affects driving.
            </li>
            <li data-id="element-1835">
              Lessons will be stopped if your instructor deems you unfit to
              drive, and the full lesson fee will still apply.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1836">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1837">
            6. Driving Tests
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1838">
            <li data-id="element-1839">
              Instructors will only take pupils to a test if they are judged
              "test ready".
            </li>
            <li data-id="element-1840">
              Use of the tuition car for a DVSA driving test is at the
              instructor's discretion.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1841">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1842">
            7. Liability
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1843">
            <li data-id="element-1844">Our vehicles are insured and maintained to a safe standard.</li>
            <li data-id="element-1845">
              Northampton Driving School is not liable for DVSA test
              cancellations, delays, fines, or penalties incurred by pupils.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1846">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1847">
            8. Prices & Changes
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1848">
            <li data-id="element-1849">
              Prices may change at any time, but prior notice will be given
              where possible.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1850">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1851">
            9. Complaints
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1852">
            <li data-id="element-1853">
              Please first raise any concerns directly with your instructor.
            </li>
            <li data-id="element-1854">
              If unresolved, email info@northamptondrivingschool.co.uk. We aim
              to reply within 14 days.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1855">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1856">
            10. Governing Law
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1857">
            <li data-id="element-1858">These Terms are governed by the laws of England and Wales.</li>
          </ul>
        </section>
      </div>
    </div>;
};
export default TermsPage;